export const CAPSULE_FRAME_ID = 'inside-preview';
export const STATIC_FRAME_ID = 'static-site'